import { render, staticRenderFns } from "./activity-subactivities.vue?vue&type=template&id=6371f60e&scoped=true"
import script from "./activity-subactivities.vue?vue&type=script&lang=js"
export * from "./activity-subactivities.vue?vue&type=script&lang=js"
import style0 from "./activity-subactivities.vue?vue&type=style&index=0&id=6371f60e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6371f60e",
  null
  
)

export default component.exports